<template>
  <b-card :style="{borderColor: boldTintColor, borderWidth: '1px'}" class="mb-4">
    <div class="text-center" v-if="section.image_url">
      <b-img fluid style="max-width:200px" :src="section.image_url" class="mb-3" />
    </div>
    <h4>{{section.heading}}</h4>
    <p v-if="section.details" v-newlines>
      {{section.details}}
    </p>
    <table class="table table-sm table-borderless mb-0" v-if="dataItems.length > 0" style="table-layout:fixed">
      <tbody>
        <data-item-row v-for="(item, index) in dataItems" :item="item" :key="index"></data-item-row>
      </tbody>
    </table>
    <data-entry-form :fields="dataEntryItems" v-if="dataEntryItems.length > 0" ref="form" v-on:submit="submitForm"></data-entry-form>
    <p v-if="section.footing">
      {{section.footing}}
      <span v-if="section.footing_additional">
        <br>
        {{section.footing_additional}}
      </span>
    </p>
    <div v-for="(subsection, index) in section.data_sections" :key="index" :class="timeline ? '' : 'mb-5'">
      <template v-if="index > 0">
        <div class="text-center" v-if="timeline">
          <span style="display:block;border: 1px solid rgba(0,0,0,.125); margin: 0 auto; height: 2em; width: 1px"></span>
        </div>
        <!-- <div class="mb-3" v-else="true">&nbsp;</div> -->
      </template>
      <b-card no-body class="mb">
        <table class="table table-sm table-borderless mb-0" style="table-layout:fixed">
          <tbody>
            <tr v-if="subsection.heading != null">
              <th colspan="3">{{subsection.heading}}</th>
            </tr>
            <data-item-row v-for="(item, index) in subsection.data_items" :item="item" :key="index"></data-item-row>
          </tbody>
        </table>
        <div slot="footer" v-if="subsection.footing">
          {{subsection.footing}}
          <span v-if="subsection.footing_additional">
            <br>
            {{subsection.footing_additional}}
          </span>
        </div>
      </b-card>
    </div>
  </b-card>
</template>


<script>
import DataItemRow from '@/components/DataItemRow'
import DataEntryForm from '@/components/DataEntryForm'

export default {
  name: 'DataSection',
  components: {
    'data-item-row': DataItemRow,
    'data-entry-form': DataEntryForm
  },
  props: {
    section: { type: Object },
    timeline: { type: Boolean, default: false },
    boldTintColor: { type: String, default: 'black' },
    lightTintColor: { type: String, default: 'white' }
  },
  data () {
    return { modalImage: null }
  },
  directives: {
    newlines: {
      inserted (el) {
        // simplified example,
        // works only for nodes without any child elements
        el.innerHTML = el.textContent.replace(/\n/g, '<br>')
      }
    }
  },
  computed: {
    dataItems () {
      if (this.section.data_items != null) {
        return this.section.data_items
      } else {
        return []
      }
    },
    dataEntryItems () {
      if (this.section.data_entry_items != null) {
        return this.section.data_entry_items
      } else {
        return []
      }
    }
  },
  methods: {
    showImage (image) {
      this.modalImage = image
      this.$refs.imageModal.show()
    },
    validate () {
      if (this.$refs.form != null) {
        return this.$refs.form.validate()
      } else {
        return true
      }
    },
    values () {
      if (this.$refs.form != null) {
        return this.$refs.form.values()
      } else {
        return []
      }
    },
    submitForm () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataSection.vue